import { AnyAction, Reducer } from 'redux';

export const loadEnvironment = async (): Promise<EnvironmentState> => {
  const response = await fetch('/config.json', { method: 'GET' });
  try {
    return await response.json();
  } catch (error) {
    return Promise.reject('Could not load config.json!!');
  }
};

export interface EnvironmentState {
  DEV_MODE?: string;
  ENV_MODE?: string;
  API_URL?: string;
  ORDER_UPLOAD_URL?: string;
  DESIGNER_PORTAL_URL?: string;
  ADMIN_PORTAL_URL?: string;
  ASYNC_UPLOAD?: string;
  SIGNUP_UPLOAD_URL?: string;
}

export const STORE_ENV_CONFIG = 'environment/store-env-config';

const reducer: Reducer<EnvironmentState> = (
  state: EnvironmentState = {},
  action: AnyAction
): EnvironmentState => {
  switch (action.type) {
    case STORE_ENV_CONFIG:
      return {
        ...state,
        DEV_MODE: action.DEV_MODE,
        ENV_MODE: action.ENV_MODE,
        // // Local url's
        // API_URL: 'http://localhost:3018/',
        // ORDER_UPLOAD_URL: 'http://localhost:3018/',
        // DESIGNER_PORTAL_URL: 'http://192.168.30.66:3012/login',
        // ADMIN_PORTAL_URL: 'https://designconnect.mylabconnect.com/admin',
        // SIGNUP_UPLOAD_URL: 'https://designconnect.mylabconnect.com/admin/customwebservice.asmx/',

        // Test url's
        API_URL: 'https://designconnect.mylabconnect.com:3018/',
        ORDER_UPLOAD_URL: 'https://designconnect.mylabconnect.com:3013/',
        DESIGNER_PORTAL_URL: 'https://designconnect.mylabconnect.com:3012/',
        ADMIN_PORTAL_URL: 'https://designconnect.mylabconnect.com/admin',
        SIGNUP_UPLOAD_URL: 'https://designconnect.mylabconnect.com/admin/customwebservice.asmx/',

        // Dev Server url's
        // API_URL: 'http://192.168.30.66:3018/',
        // ORDER_UPLOAD_URL: 'http://192.168.30.66:3013/',
        // DESIGNER_PORTAL_URL: 'http://192.168.30.66:3012/login',
        // ADMIN_PORTAL_URL: 'http://192.168.30.66:3022/admin/aspx/signin.aspx',
        // SIGNUP_UPLOAD_URL: 'http://192.168.30.66:3022/admin/customwebservice.asmx/',

        // Live url's
        // API_URL: 'https://easydentconnect.com:3018/',
        // ORDER_UPLOAD_URL: 'https://easydentconnect.com:3013/',
        // DESIGNER_PORTAL_URL: 'https://easydentconnect.com:3012/',
        // SIGNUP_UPLOAD_URL: 'https://easydentconnect.com/admin/customwebservice.asmx/',
        // ADMIN_PORTAL_URL: 'https://easydentconnect.com/admin',

        ASYNC_UPLOAD: 'true', // 'false';
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/environment/Environment.ts